import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { CardPaymentsSchema, cardPaymentsReady, paths, type CardPayments } from "@clevis/shared-types";
import { db } from "../lib/firebase";

// The company's card-payment setup (its own Stripe account), live. `ready`
// means Stripe has charges on: card buttons show only then.
export function useCardPayments(tenantId: string | null): { payments: CardPayments | null; ready: boolean } {
  const [payments, setPayments] = useState<CardPayments | null>(null);
  useEffect(() => {
    if (!tenantId) return;
    return onSnapshot(
      doc(db, paths.tenantCardPayments(tenantId)),
      (snap) => setPayments(CardPaymentsSchema.parse(snap.data() ?? {})),
      () => setPayments(CardPaymentsSchema.parse({})),
    );
  }, [tenantId]);
  return { payments, ready: cardPaymentsReady(payments) };
}
